import { useContext, } from "react";
import { LangContext } from "../../context/langContext/LangContext";
import { changeLang } from "../../context/langContext/LangActions";


const languages = [
    { code: "fr", lang: "Français" },
    { code: "ar", lang: "Arabe" },
    { code: "en", lang: "Anglais" },
];
export default function LanguageSelector({languageDisplay}) {
    const { dispatch, lang } = useContext(LangContext)

    const changeLanguage = (lng) => {
        dispatch(changeLang(lng));
    };

    return (
        <div className="lang" style={{ display: languageDisplay ? "": "none" }}>
            <span className={languages.filter(item => item.code === lang)[0]['code']}></span>
            <span>{languages.filter(item => item.code === lang)[0]['lang']}</span>
            <span className="material-symbols-rounded">keyboard_arrow_down</span>
            <ul>
                {
                    languages.map((lng, index) => (
                        <li key={index} onClick={() => changeLanguage(lng.code)} className={lang === lng.code ? "selected" : ""}>
                            <span></span>
                            <span>{lng.lang}</span>
                        </li>
                    ))
                }
            </ul>
        </div>
    )
}
